export default __webpack_public_path__ + "static/media/featureproject1.ccc1cd7e.png";